import { hash } from "hash-it";

export default function getObjectHash(object: unknown) {
    return hash(object).toString();
}
